import {Link} from "react-router-dom";

const NotFound = ()=>{
    return(
        <>
            <div className="not-found">

                <p>upss... parece que te equivocaste, vuelve a la pagina anterior</p><br/>
                <Link to='/' className="start">  ir a inicio</Link>
            </div>
        </>
    )
}

export default NotFound